import { filterByPermission } from './PermissionGate';

// RC19.x Role-Aware UI — Layout.js's sidebar (and any other nav/menu list, e.g. a Quick Actions
// menu) was already 100% permission-driven (no role-name checks — those were already removed in
// RC14.0), but as ~40 individually hand-written `const canViewX = authService.hasPermission(...)`
// booleans each paired with its own `...(canViewX ? [{...}] : [])` spread. Correct, but scattered
// — the same conditional-array-membership shape repeated by hand instead of declared as data.
// This is that one filter, applied to a plain nav-item array instead.
//
// `items`: [{ text, icon, path, permission?, ...anything-else-the-caller-renders-with }] —
// `permission` may be a single code or an array (OR semantics, matching AdminRoute/PermissionGate);
// omitted means always visible.
export const getVisibleNavItems = filterByPermission;
